<template>
	<div class="flow-pagination-container" :position="position">
		<Icon
			name="i-chevron-left"
			type="filled"
			state="dark"
			size="small"
			:disabled="offset <= 0 || loading"
			@click="prev()"
		/>
		<p v-if="!loading" class="paragraph-1 fc-normal">
			{{ label }}
		</p>
		<Icon v-if="loading" size="small" name="loading" />
		<p v-if="loading" class="paragraph-1 fc-normal loading-text">Loading...</p>
		<Icon
			name="i-chevron-right"
			type="filled"
			state="dark"
			size="small"
			:disabled="offset + max >= total || loading"
			@click="next()"
		/>
	</div>
</template>
<script>
import { defineComponent } from "vue";
import Icon from "./../Icon/Icon";

export default defineComponent({
	name: "Pagination",
	components: {
		Icon
	},
	props: {
		/**
		 * Total number of results
		 */
		total: {
			type: Number,
			default: 0
		},
		/**
		 * Maximum results to display per page
		 */
		max: {
			type: Number,
			default: 0
		},
		/**
		 * Offset results (Used for pagination cursor) <br/> This is updated whenever next or previous arrow clicked.<br/>NOTE : Use 'offset.sync' for 2 way binding
		 */
		offset: {
			type: Number,
			default: 0
		},
		/**
		 * By default this is displayed at bottom right of page, But if we want to display at any relative container then use 'absolute'
		 */
		position: {
			type: String,
			default: "fixed"
		},
		/**
		 * Display loader
		 */
		loading: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		label() {
			const ordinal = n => {
				const s = ["th", "st", "nd", "rd"];
				const v = n % 100;
				return n + (s[(v - 20) % 10] || s[v] || s[0]);
			};

			let lastIndex = this.offset + this.max;
			const firstIndex = this.offset + 1;

			if (lastIndex > this.total) {
				lastIndex = this.total;
			}
			if (lastIndex === firstIndex) {
				return `${ordinal(firstIndex)} of ${this.total}`;
			}
			return `${firstIndex} - ${lastIndex} of ${this.total}`;
		}
	},
	methods: {
		next() {
			const nextOffset = this.offset + this.max;
			/**
			 * To update offset in parent
			 *
			 * @event update:offset
			 */
			this.$emit("update:offset", nextOffset);

			/**
			 * Whenever Next is clicked.
			 *
			 * @event next
			 */
			this.$emit("next", nextOffset);
		},
		prev() {
			const prevOffset = this.offset - this.max;
			this.$emit("update:offset", prevOffset);

			/**
			 * Whenever Previous is clicked.
			 *
			 * @event prev
			 */
			this.$emit("prev", prevOffset);
		}
	}
});
</script>
<style lang="scss">
div.flow-pagination-container {
	display: flex;

	z-index: 90;

	border-radius: 8px 8px 0px 0px;
	background-color: var(--dashboard-element-light);
	height: 50px;

	align-items: center;
	justify-content: space-between;
	padding: 0px 24px 0px 24px;

	> * + * {
		margin-left: 24px;
		&.loading-text {
			margin-left: 8px;
		}
	}

	bottom: 0px;
	right: 24px;

	&[position="fixed"] {
		position: fixed;
	}
	&[position="absolute"] {
		position: absolute;
	}
}
</style>
